module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/transworld-expedition-ship-truck/transworld-expedition-ship-truck.component.scss
// module id = 841
// module chunks = 0